import {Component, Input, OnInit} from '@angular/core';
import {ClassType, Format, TableApp, TableColumn, TableFormat, Transaction} from "@app/shared";
import {SelectItem} from "primeng/api";

@Component({
  selector: 'app-data-table-renderer',
  templateUrl: './data-table-renderer.component.html',
  styleUrls: ['./data-table-renderer.component.css']
})
export class DataTableRendererComponent implements OnInit {

  TableApp: typeof TableApp = TableApp;
  TableFormat: typeof TableFormat = TableFormat;
  Transaction: typeof Transaction = Transaction;
  Format: typeof Format = Format;
  ClassType: typeof ClassType = ClassType;
  viewOptions: SelectItem[] = [{label: "Yes", value: true}, {label: "No", value: false}];

  @Input() rowNode: any;
  @Input() row: any;
  @Input() rowData: any;
  @Input() rowIndex: number;
  @Input() col: TableColumn;
  @Input() expanded: any;
  @Input() orgIds: number[];

  constructor() {
  }

  ngOnInit(): void {
  }

}
